import '../../sass/layout/sections/section-belt.scss';
import '../../sass/layout/page/page-home.scss'


import Swiper, {
    Pagination,
    Autoplay,
} from 'swiper';

const swiperNews = document.querySelector('.swiper-news');

if (swiperNews) {
    const pagination = swiperNews.querySelector('.swiper-pagination');

    const options = {
        modules: [Pagination, Autoplay],
        loop: false,
        speed: 1000,
        pagination: {
            el: pagination,
            clickable: true
        },
        autoplay: false,
        autoplay: {
            delay: 5000,
        },
        init: true,
    }


    const swiper = new Swiper(swiperNews, options);

}

